import { jwtDecode } from 'jwt-decode';

export const checkUserRole = () => {
  const token = localStorage.getItem('token');
  let role = null;

  if (token) {
    const decodedToken = jwtDecode(token);
    role = decodedToken.role; // Assuming the role is stored in the 'role' field of the token
  }

  return role;
};